import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
// import { APP_LABEL } from '../constants/deviceStatus/statusLabels'
// import { APP_STATUS } from '../constants/deviceStatus/deviceStatus'

export default {
  computed: {
    tenants: function () { return this.$store.state.tenantsList.data }
  },
  data: function () {
    return {
      tenantGroupList: [],
      addedTenants: [],
      selectedTenant: '',
      selectedGroup: {},
      updateGroup: {},
      newGroupName: '',
      tenantGroupFields: {
        'tenant_group_id': {
          label: 'ID',
          tdClass: 'custom-td-width'
        },
        'tenant_group_name': {
          label: 'Tenant'
        }
      }
    }
  },

  // _rowVariant: 'is-child',
  //   _cellVariants: { status: 'status' }
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      if (this.$store.state.tenantGroupList.length < 1) {
        this.fetchTenantGroupsList()
      } else {
        this.tenantGroupList = this.$store.state.tenantGroupList
        this.setupTenantGroupList()
      }
    }
  },
  destroyed () {
    this.flushTenantGroupList()
  },
  methods: {
    fetchTenantGroupsList () {
      this.$store.dispatch(APIEvent.FETCH_TENANT_GROUPS, {})
        .then(() => {
          this.tenantGroupList = this.$store.state.tenantGroupList
          this.setupTenantGroupList()
        })
        .catch(this.handleError)
    },
    setupTenantGroupList: function () {
      for (var i = 0; i < this.tenantGroupList.length; i++) {
        let group = this.tenantGroupList[i]
        group.expanded = false
      }
    },
    expandItem: function (data) {
      if (!data.item.expanded) {
        let options = {tenant_group_id: data.item.tenant_group_id}
        this.$store.dispatch(APIEvent.FETCH_GROUP_TENANTS, options)
          .then((res) => {
            this.addedTenants = res.data.list.record
            this.addItems(data)
            data.item.expanded = true
          })
          .catch((err) => {
            if (err.error === 307) {
              this.addedTenants = []
              this.addItems(data)
              data.item.expanded = true
            } else {
              this.handleError(err)
            }
          })
      } else {
        this.removeItems(data)
        data.item.expanded = false
      }
    },
    addItems: function (data) {
      this.closeAll()
      let index = 0
      for (let j = 0; j < this.tenantGroupList.length; j++) {
        let group = this.tenantGroupList[j]
        if (group.tenant_group_id === data.item.tenant_group_id) {
          this.selectedGroup = data.item
          this.selectedTenant = null
          index = j
          break
        }
      }
      index++
      let tenants = this.addedTenants
      for (let i = 0; i < tenants.length; i++) {
        let tenant = tenants[i]
        tenant._rowVariant = 'is-child'
        tenant.tenant_group_name = tenant.tenant_name
        this.tenantGroupList.splice(index, 0, tenant)
        index++
      }
      let form = {}
      form._rowVariant = 'form'
      this.tenantGroupList.splice(index, 0, form)
    },
    closeAll: function () {
      for (let i = 0; i < this.tenantGroupList.length; i++) {
        let group = this.tenantGroupList[i]
        if (group.expanded) {
          this.removeItems({item: group})
          group.expanded = false
        }
      }
    },
    removeItems: function (data) {
      let groupId = data.item.tenant_group_id
      let removeFlag = false
      let removeIndex = 0
      let removeCount = 0
      // only do this if tenants have been added previously
      if (this.addedTenants.length >= 0) {
        let groups = this.tenantGroupList
        for (let i = 0; i < groups.length; i++) {
          if (groupId === groups[i].tenant_group_id) {
            // we've found the parent item store its index
            // and count how many children it has
            removeFlag = true
            removeIndex = i + 1
            continue
          } else if (removeFlag) {
            // all children have a _rowVariant property
            if (groups[i].hasOwnProperty('_rowVariant')) {
              removeCount++
            } else {
              // no _rowVariant property means no more children
              removeFlag = false
              break
            }
          }
        }
        // only perform this if we found something
        if (removeCount > 0) {
          this.tenantGroupList.splice(removeIndex, removeCount)
        }
      }
    },
    subscribeTenant: function () {
      if (this.selectedTenant !== null) {
        let options = {}
        options.tenant_group_id = this.selectedGroup.tenant_group_id
        options.tenant_id = this.selectedTenant['id']

        this.$store.dispatch(APIEvent.ADD_TENANT_TO_GROUP, options)
          .then(() => {
            EventBus.$emit(StatusBarEvent.SUCCESS,
              'Tennant succesfully added to group')
            this.expandItem({item: this.selectedGroup})
          })
          .catch(this.handleError)
      } else {
        EventBus.$emit(StatusBarEvent.WARNING, 'Please select a tenant')
      }
    },
    createTenantGroup: function (event) {
      if (this.newGroupName.trim() === '') {
        EventBus.$emit(StatusBarEvent.WARNING, 'Please enter a group name')
        event.preventDefault()
      } else {
        let options = {tenant_group_name: this.newGroupName}
        this.$store.dispatch(APIEvent.ADD_TENANT_GROUP, options)
          .then(() => {
            this.flushTenantGroupList()
            this.fetchTenantGroupsList()
            EventBus.$emit(StatusBarEvent.SUCCESS, 'New tenant group added')
          })
          .catch(this.handleError)
      }
    },
    editTenantName: function (data) {
      this.updateGroup = data.item
      this.$refs.renameTenantGroupModal.show()
    },
    renameTenantGroup: function (event) {
      if (this.updateGroup.tenant_group_name.trim() === '') {
        EventBus.$emit(StatusBarEvent.WARNING, 'Please enter a group name')
        event.preventDefault()
      } else {
        let options = {
          name: this.updateGroup.tenant_group_name,
          tenant_group_id: this.updateGroup.tenant_group_id
        }
        this.$store.dispatch(APIEvent.UPDATE_TENANT_GROUP, options)
          .then(() => {
            this.flushTenantGroupList()
            this.fetchTenantGroupsList()
            EventBus.$emit(StatusBarEvent.SUCCESS, 'Tenant group renamed')
          })
          .catch(this.handleError)
      }
    },
    deleteItem: function (data) {
      let options = {tenant_group_id: data.item.tenant_group_id}
      this.$store.dispatch(APIEvent.DELETE_TENANT_GROUP, options)
        .then(() => {
          this.flushTenantGroupList()
          this.fetchTenantGroupsList()
          EventBus.$emit(StatusBarEvent.SUCCESS, 'Tenant group succesfully removed')
        })
        .catch(this.handleError)
    },
    deleteChild: function (data) {
      let options = {}
      options.tenant_group_id = this.selectedGroup.tenant_group_id
      options.tenant_id = data.item.tenant_id
      this.$store.dispatch(APIEvent.DELETE_TENANT_FROM_GROUP, options)
        .then(() => {
          this.expandItem({item: this.selectedGroup})
          EventBus.$emit(StatusBarEvent.SUCCESS, 'Tenant succesfully removed from group')
        })
        .catch(this.handleError)
    },
    determineExpandClass: function (data) {
      if (typeof data.item._rowVariant === 'undefined') {
        return data.item.expanded === false ? 'icon-plus' : 'icon-minus'
      } else {
        return ''
      }
    },
    determineDeleteClass: function (data) {
      if (typeof data.item._rowVariant === 'undefined') {
        return 'master-icon-close icon-close'
      } else {
        return ''
      }
    },
    flushTenantGroupList: function () {
      let clearData = {}
      clearData.prop = 'SET_TENANT_GROUPS'
      clearData.value = []
      this.$store.dispatch(APIEvent.CLEAR, clearData)
    },
    isForm: function (data) {
      let type = data.item._rowVariant
      return typeof type !== 'undefined' && type === 'form'
    },
    isChild: function (data) {
      return typeof data.item._rowVariant !== 'undefined'
    },
    getTenantLabelClass: function (data) {
      if (!this.isForm(data) && !this.isChild(data)) {
        return 'tenant-label deviceLink'
      } else {
        return 'tenant-label'
      }
    },
    clearInput: function () {
      this.newGroupName = ''
    },
    handleError: function (error) {
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    }
  }
}
